import React, { Component } from 'react'

const remoteSearchHOC = WrappedComponent => (
	class RemoteSearchWrapper extends Component {
		state = {
			searchParams: {
				string: '',
				columns: [this.props.remoteOptions.labelField || 'name']
			}
		}

		handleSearch = (val, { action }) => {
			const { remoteResult } = this.props
			const { queryVariables = {} } = remoteResult
			const { searchParams } = this.state
			if(action === 'input-change') {
				if(this.timer) {
					clearTimeout(this.timer)
				}
				this.timer = setTimeout(() => {
					remoteResult.refetch({ ...queryVariables, params: { ...queryVariables.params, search: { string: val, columns: ['name'] } } })
					this.setState({ searchParams: { ...searchParams, string: val } })
				}, 800)
			}

			if(action === 'menu-close' && searchParams.string) {
				remoteResult.refetch(queryVariables)
				this.setState({ searchParams: { ...searchParams, string: '' } })
			}
		}

		render() {
			return(
				<WrappedComponent
					{...this.props}
					{...this.state.searchParams.string && { searchParams: this.state.searchParams }}
					onInputChange={this.handleSearch} />
			)
		}
	}
)

export default remoteSearchHOC
